$(document).ready(function () {
  // Header Menu
  $(".menu_btn").on('click', function () {
    $(".menu_wrapper").addClass("active");
    $(".modal_bg").addClass("active");
    $("body").addClass("ov_hi");
  });
  $(".menu_close").on('click', function () {
    $(".menu_wrapper").removeClass("active");
    $(".modal_bg").removeClass("active");
    $("body").removeClass("ov_hi");
  });

  // $(".results_filter").on('click', function () {
  //   $(".collection_filter").addClass("active");
  // });

  $(".menu_close").on('click', function () {
    $(".collection_filter").removeClass("active");
  });

  $(".filter_btn").on('click', function () {
    $(".filter_wrapper").addClass("active");
  });

  $(".menu_close").on('click', function () {
    $(".filter_wrapper").removeClass("active");
  });


  // Open modal
  $('.open_modal').on('click',function (e) {
    e.preventDefault();
    var target = $(this).data('target');
    $(target).fadeIn(200);
    $('body').addClass('ov_hi');
  });

  // Close modal on X or OK
  $('.close_btn, .ok-btn').on('click',function (e) {
    e.preventDefault();
    $(this).closest('.about_modal').fadeOut(200);
    $('body').removeClass('ov_hi');
  });

  //Close modal on outside click
  $(window).on('click', function (e) {
    if ($(e.target).hasClass('dropshadow')) {
      e.preventDefault();
      $('.about_modal').fadeOut(200);
      $('body').removeClass('ov_hi');
    }
      
  });

  // accordion js start
  $(document).on('click', '.accordion_block .accordion_header', function () {
    var $header = $(this);
    var $block = $header.closest('.accordion_block');
    var $content = $header.next('.accordion_content');

    // Close all accordions in this block
    $block.find('.accordion_header').removeClass('active');
    $block.find('.accordion_content').slideUp();

    // Open the clicked accordion
    if (!$content.is(':visible')) {
      $content.slideDown();
      $header.addClass('active');
    }
  });

  // accordion js end
  $(".filter_btn").on('click', function () {
    $(".filter_wrapper").addClass("active");
    $(".modal_bg").addClass("active");
  });

  $(".menu_close").on('click', function () {
    $(".filter_wrapper").removeClass("active");
    $(".modal_bg").removeClass("active");
  });

  /* Start - PDP - Tab structure(I’m Interested In Treatments For) */ 
  $('#tabs-nav li:first-child').addClass('active');
  $('.tab-content').hide();
  $('.tab-content:first').show();

  // Click function
  $('#tabs-nav li').click(function(){
    $('#tabs-nav li').removeClass('active');
    $(this).addClass('active');
    $('.tab-content').hide();
    
    var activeTab = $(this).find('a').attr('href');
    $(activeTab).fadeIn();
    return false;
  });

  //Mob select for change tab
  $('.mob_tab_select').on('change', function () {
    var activeTab = $(this).val();  
    $('#tabs-nav li').removeClass('active');
    $('.tab-content').hide();
    $(activeTab).fadeIn();
    $('#tabs-nav li a[href="'+ activeTab +'"]').parent().addClass('active');
  }); 
  /* End - PDP - Tab structure(I’m Interested In Treatments For) */ 

  $('.pdp_details_learn').on('click', function(e){
    e.preventDefault();
    var headerHeight = $('header').outerHeight();

    $('html, body').animate({
      scrollTop: $('.what-is-botox').offset().top - headerHeight
    }, 800);
  });


  if (window.innerWidth <= 768) {
    // $('body').on('click', '.menu_link', function (e) {
    //   e.preventDefault();
    //   $(this).next('.mega_menu').addClass('active');
    //   $(this).next('.dropdown').addClass('active');
    // });

    $('body').on('click', '.menu_right_icon', function (e) {
      e.preventDefault();
      console.log($(this).parent());

      const mega = $(this).parent().next('.mega_menu');
      const drop = $(this).parent().next('.dropdown');

      if (mega.length) {
        mega.addClass('active');
      } 
      else if (drop.length) {
        drop.addClass('active');
      }
    });

    document.querySelectorAll('.back_menu').forEach(button => {
      button.addEventListener('click', (e) => {
        const drawer = button.closest('.mega_menu, .dropdown');
        if (drawer) {
          drawer.classList.remove('active');
        }
      });
    });
  }
});

if(document.querySelector('.mob_cart_icon')){
  document.querySelector('.mob_cart_icon').addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('#cart-icon-bubble').click(); 
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}


const trapFocusHandlers = {};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {

    //collection accordion
    if(e.target.closest('.accordion_header')){
     // collectionAccordion(e.target);
    }

    //mob filter drawer
    let collectionFilter = document.querySelector('.collection_filter');
    if(e.target.closest('.results_filter')){
      e.preventDefault();		
      collectionFilter.classList.add('active');
      return;
    }

    if(collectionFilter &&
    collectionFilter.classList.contains('active') &&
    !collectionFilter.contains(e.target)){
      e.preventDefault();		
      collectionFilter.classList.remove('active');
    }
  });
});

function collectionAccordion(target){
  const header = target.closest('.accordion_header');
    if (!header) return;

    const block = header.closest('.accordion_block');
    if (!block) return;
    
    const allHeaders = block.querySelectorAll('.accordion_header');
    const allContents = block.querySelectorAll('.accordion_content');   
    const content = header.nextElementSibling;
    
    if (content && content.classList.contains('accordion_content')) {      
      if (window.getComputedStyle(content).display === 'none') {
        allHeaders.forEach(h => h.classList.remove('active'));
        allContents.forEach(c => {
          c.style.display = 'none';
        });
        content.style.display = 'block';
        header.classList.add('active');
      }else{ 
        content.style.display = 'none';
        header.classList.remove('active');
      }
    }
    
}

var home_banner_siderSwiper = new Swiper(".home_banner_sider", {
  loop: true,
  effect: 'fade',
  spaceBetween: 30,
  pagination: {
    el: ".swiper-pagination",
  },
});

// --------- product media slider ----------
var prod_media_slider = new Swiper(".prod_media_slider", {
  loop: false,
  slidesPerView: 1
});

var recent_blog_slider = new Swiper(".recent_blog_slider", {
  loop: false,
  slidesPerView: 3,
  spaceBetween: 30,
  breakpoints: {
    1440: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    1025: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    0: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
  },
});

function updateBlogAnimations() {
  const slides = document.querySelectorAll('.recent_blog_slider .swiper-slide');

  // Screen between 768 and 1024 (inclusive)
  if (window.innerWidth <= 1024 && window.innerWidth >= 768) {
    slides.forEach(slide => {
      if (slide.classList.contains('animate__fadeIn')) {
        slide.classList.remove('animate__fadeIn');
        slide.classList.add('animate__fadeInRight');
      }
    });
  }
}

// Run on page load
updateBlogAnimations();

// Run on window resize
window.addEventListener('resize', updateBlogAnimations);




// ------patient_slider--
var patient_sliderSwiper = new Swiper(".patient_slider", {
  loop: true,
  slidesPerView: 3,
  spaceBetween: 30,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".arrow_next",
    prevEl: ".arrow_prev",
  },
  breakpoints: {
    1440: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    1025: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    0: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
  },

});


// ------cutting_slider--
var cutting_sliderSwiper = new Swiper(".cutting_slider", {
  loop: true,
  slidesPerView: 3,
  spaceBetween: 20,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".cutting_arrow_next",
    prevEl: ".cutting_arrow_prev",
  },
  breakpoints: {
    1440: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1025: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    600: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    0: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
  },

});

var img_slider_4x5 = new Swiper(".img_slider_4x5", {
  loop: true,
  slidesPerView: 3,
  spaceBetween: 20,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".cutting_arrow_next",
    prevEl: ".cutting_arrow_prev",
  },
  breakpoints: {
    1440: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1025: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    600: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    0: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
  },

});

var video_slider_9x16 = new Swiper(".video_slider_9x16", {
  loop: true,
  slidesPerView: 3,
  spaceBetween: 20,
  speed: 4000,
  // autoplay: {
  //   delay: 1000,
  //   disableOnInteraction: false,
  // },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".cutting_arrow_next",
    prevEl: ".cutting_arrow_prev",
  },
  breakpoints: {
    1440: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1025: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    600: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    0: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
  },

});
// -----------------animation-----sctipt----section-scroll----------------

jQuery(function ($) {

  var doAnimations = function () {

    // Calc current offset and get all animatables
    var offset = $(window).scrollTop() + $(window).height(),

      $animatables = $('.animatable');
    $('.stat-number').each(function () {
      var size = $(this).text().split(".")[1] ? $(this).text().split(".")[1].length : 0;
      $(this).prop('Counter', 0).animate({
        Counter: $(this).text()
      }, {
        duration: 5000,
        step: function (func) {
          $(this).text(parseFloat(func).toFixed(size));
        }
      });
    })

    // Unbind scroll handler if we have no animatables
    if ($animatables.length == 0) {
      $(window).off('scroll', doAnimations);
    }

    // Check all animatables and animate them if necessary
    $animatables.each(function (i) {
      var $animatable = $(this);
      if (($animatable.offset().top + $animatable.height() - 20) < offset) {
        $animatable.removeClass('animatable').addClass('animated');
      }
    });

  };

  // Hook doAnimations on scroll, and trigger a scroll
  $(window).on('scroll', doAnimations);
  $(window).trigger('scroll');

});




/** -----------on scroll section Animation----------------- */
$(document).ready(function () {

  /** ---------------------------- //
   *  @group viewport trigger script 
   * for adding or removing classes from elements in view within viewport
  */

  var $animationElements = $('.animation-element');
  var $window = $(window);

  // ps: Let's FIRST disable triggering on small devices!
  // var isMobile = window.matchMedia("only screen and (max-width: 768px)");
  // if (isMobile.matches) {
  //     $animationElements.removeClass('animation-element');
  // }

  function checkIfInView() {

    var windowHeight = $window.height();
    var windowTopPosition = $window.scrollTop();
    var windowBottomPosition = (windowTopPosition + windowHeight);

    $.each($animationElements, function () {
      var $element = $(this);
      var elementHeight = $element.outerHeight();
      var elementTopPosition = $element.offset().top;
      var elementBottomPosition = (elementTopPosition + elementHeight);

      //check to see if this current container is within viewport
      if ((elementBottomPosition >= windowTopPosition) &&
        (elementTopPosition <= windowBottomPosition)) {
        $element.addClass('in-view');
      } else {
        $element.removeClass('in-view');
      }
    });
  }

  $window.on('scroll resize', checkIfInView);
  $window.trigger('scroll');
});
/** -----------on scroll section Animation----------------- */





/** -----------Wow-Animation----------------- */
new WOW().init();
/** -----------Wow-Animation----------------- */



/** -----------Header-css------------------ */
document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("header");

  window.addEventListener("scroll", function () {
    if (window.scrollY > 50) {
      header.classList.add("is-sticky");
    } else {
      header.classList.remove("is-sticky");
    }
  });
});

/** -----------Header-css------------------ */


/** -----------Header-space-css------------------ */

$(document).ready(function () {
  function headerspace() {
    var headerHeight = $('.header').outerHeight();
    var anHeight = $('.announcement_bar').outerHeight();
    $('body').css('--header-height', headerHeight + 'px');
    $('body').css('--announcement-height', anHeight + 'px');
  }
  headerspace();
  $(window).on('resize orientationchange', function () {
    headerspace();
  });
});
/** -----------Header-space-css------------------ */


document.addEventListener('click', function (e) {

  /* --------------------------
     APPLY DISCOUNT
  ---------------------------*/
  const applyBtn = e.target.closest('.btn-apply');
  if (applyBtn) {
    addDiscount(e);
    return;
  }

  /* --------------------------
     REMOVE DISCOUNT
  ---------------------------*/
  const removeBtn = e.target.closest('.remove-discount');
  if (removeBtn) {
    removeDiscount(e);
    return;
  }

});


var addDiscount = async (e) => {
  e.preventDefault();
  let target = e.target;
  let cartWrapper = target.closest('[data-cart]');
  let cartDiscountContent = cartWrapper?.querySelector('.cart-discount-content');
  let cartType = cartDiscountContent.dataset.source;
  let discountErrorWrap = cartDiscountContent?.querySelector('.discount-error-wrap');
  let discountCode = cartDiscountContent.querySelector('.input_discount').value;
  let cartSource =  target.dataset.source;
  let sections = ['main-cart', 'cart-drawer', 'cart-icon-bubble'];

  const existingDiscount = existingDiscounts(target);
  if(existingDiscount.includes(discountCode)) return;
  
  existingDiscount.push(discountCode);    
  
  const body = JSON.stringify({ discount: existingDiscount.join(','),sections: sections });
    
  try {
    const response = await fetch(`${routes.cart_update_url}`, {
      ...fetchConfig(),
      body
    });
    
    const data = await response.json();
    console.log('data', data);
    if(data.discount_codes.length > 0 && data.discount_codes.find((discount) => {
      return discount.code === discountCode && discount.applicable == false
    })){ 
      cartDiscountContent.querySelector('.discount').value = '';
      discountErrorWrap.classList.remove('hidden');
      console.log('error-wrap',cartDiscountContent.querySelector('.discount-error-wrap'));
    }else{      

      if (cartType === 'drawer') {
        const cartDrawer = document.querySelector('cart-drawer');
        cartDrawer?.renderContents(data);
        //console.log(cartDiscountContent.querySelector('.drawer_discount_applied'));
        document.querySelector('.drawer_discount_applied').style.display = "block";
        setTimeout(function() {
            document.querySelector('.drawer_discount_applied').style.display = "none";
        }, 3000);
      }else if(cartType === 'main-cart'){ 
        
        const mainCart = document.querySelector('main-cart');
        mainCart.innerHTML = data.sections['main-cart'];
        document.querySelector('.product_right_promo .accordion_header').click();
        document.querySelector('.main_cart_discount_applied').style.display = "block";
        setTimeout(function() {
            document.querySelector('.main_cart_discount_applied').style.display = "none";
        }, 3000);
      } 
    }    
    
  } catch (error) {
    console.error('Discount apply error:', error);
  }
}

var existingDiscounts = (target) => {
  let discountCodes1 = [];
  console.log(target.closest('.cart-discount-content'));
  const discountPills = target.closest('.cart-discount-content').querySelectorAll('.discount-item');
  discountCodes1 = Array.from(discountPills)
    .filter(pill => pill instanceof HTMLLIElement && pill.dataset.discountCode)
    .map(pill => pill.dataset.discountCode);
  return discountCodes1;
}

var removeDiscount = async (e) => {
  e.preventDefault();
  let target = e.target.closest('.discount-item');
  let cartWrapper = target.closest('[data-cart]');
  let cartDiscountContent = cartWrapper.querySelector('.cart-discount-content');
  let cartType = cartDiscountContent.dataset.source;
  let discountCode = target.dataset.discountCode;
  let existingDiscount = existingDiscounts(target);
  let sections = ['main-cart','cart-drawer', 'cart-icon-bubble'];
  
  const index = existingDiscount.indexOf(discountCode);
  
  if (index === -1) return;

  existingDiscount.splice(index, 1);
  const body = JSON.stringify({ discount: existingDiscount.join(','),sections: sections });  

  try {
    const response = await fetch(`${routes.cart_update_url}`, {
      ...fetchConfig(),
      body
    });
    
    const data = await response.json();
    if(data.discount_codes.length > 0 &&  data.discount_codes.find((discount) => {
      return discount.code == discountCode && discount.applicable == false
    })){
      cartDiscountContent.querySelector('.discount').value = '';
      cartDiscountContent.querySelector('.discount-error-wrap').classList.remove('hidden');
    }   

    console.log('cartType',cartType);
    if (cartType == 'drawer') {
      const cartDrawer = document.querySelector('cart-drawer');
      cartDrawer?.renderContents(data);
    }
    if (cartType == 'main-cart') { 
      const mainCart = document.querySelector('main-cart');
      mainCart.innerHTML = data.sections['main-cart'];
    }
  } catch (error) {
    console.error('Discount apply error:', error);
  }
}


document.addEventListener('DOMContentLoaded', function () {

  // Select ALL search forms
  const searchForms = document.querySelectorAll('.search-form');

  searchForms.forEach((form) => {

    const searchInput = form.querySelector('input[type="search"]');
    const resetBtn = form.querySelector('.reset__button');
    const searchBtn = form.querySelector('.search__button');

    if (!searchInput || !resetBtn || !searchBtn) return;

    // ---- Focus ----
    searchInput.addEventListener('focus', () => {
      searchBtn.classList.add('hide');
      resetBtn.classList.add('show');
    });

    // ---- Typing ----
    searchInput.addEventListener('input', () => {
      if (searchInput.value.trim().length === 0) {
        resetBtn.classList.remove('show');
        searchBtn.classList.remove('hide');
      } else {
        resetBtn.classList.add('show');
        searchBtn.classList.add('hide');
      }
    });

    // ---- Reset click ----
    resetBtn.addEventListener('click', () => {
      searchInput.value = '';
      resetBtn.classList.remove('show');
      searchBtn.classList.remove('hide');
      //searchInput.focus();
    });

    // ---- Blur ----
    searchInput.addEventListener('blur', () => {
      if (searchInput.value.trim() === '') {
        resetBtn.classList.remove('show');
        searchBtn.classList.remove('hide');
      }
    });

  });

});


 /* Product variant */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.abortController = null;
  }

  connectedCallback() {
    this.productUrl = this.dataset.productUrl;
    this.sectionId = this.dataset.section;
    this.changeURL = this.dataset.changeUrl === 'true';
    this.addButton = document.querySelector(`#product-form-${this.sectionId} [name="add"]`);
    this.inputField = document.querySelector(`#product-form-${this.sectionId} [name="id"]`);

    this.addEventListener('change', (event) => {
      const optionValues = this.selectedOptionValues.join(',');
      const requestUrl = `${this.productUrl}?section_id=${this.sectionId}&option_values=${optionValues}`;
      this.renderProductInfo(requestUrl, this.productUrl, this.sectionId, this.changeURL);
    });

    // this.addBtnText(true, '', this.addButton);
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('.swatch-block input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }

  async renderProductInfo(requestUrl, productUrl, sectionId, changeURL) {
    if (this.abortController) {
      this.abortController.abort();
    }

    this.abortController = new AbortController();
    this.addButton.disabled = true;

    try {
      const response = await fetch(requestUrl, {
        signal: this.abortController.signal,
      });
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');

      const variantElement = html.querySelector('variant-selects [data-selected-variant]');
      const variantData = variantElement ? variantElement.textContent : null;
      const variant = variantData ? JSON.parse(variantData) : null;
      // console.log('variant', variant);

      publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          sectionId: this.sectionId,
          html,
          variant,
        },
      });
      
      if (!variant) {
        this.addBtnText(true, window.variantStrings.unavailable, this.addButton);
        return;
      }
      this.inputField.value = variant.id;
      this.addBtnText(!variant.available, window.variantStrings.soldOut, this.addButton);

      if (changeURL) {
        const newUrl = `${productUrl}${variant ? `?variant=${variant.id}` : ''}`;
        window.history.replaceState({}, '', newUrl);
      }

      this.replaceContent(['price','quantity'], sectionId, html);
    } catch (error) {
      if (error.name === 'AbortError') {
        return;
      }
      console.error('Error in renderProductInfo:', error);
    }
  }

  addBtnText(disable, text, btnElement) {
    if (!btnElement) return;

    btnElement.disabled = disable;

    const span = btnElement.querySelector('span');
    if (!span) return;

    if (disable) {
      if (text) {
        span.textContent = text;
      }
    } else {
      span.textContent = window.variantStrings.addToCart;
    }
  }

  replaceContent(selectors, sectionId, html) {
    selectors.forEach((selector) => {
      const targetSelector = `[data-${selector}-${sectionId}]`;
      const target = document.querySelector(targetSelector);
      const source = html.querySelector(targetSelector);
      if (target && source) {
        target.innerHTML = source.innerHTML;
    if (selector === 'quantity') {
          target.connectedCallback();
        }
      }
    });
  }
}

customElements.define('variant-selects', VariantSelects);


